<template>
  <div class="ScreenAdapter" :style="style">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: '',
  //参数注入
  props: {
    width: {
      type: String,
      default: '1920',
    },
    height: {
      type: String,
      default: '1080',
    },
  },
  data() {
    return {
      style: {
        width: this.width + 'px',
        height: this.height + 'px',
        transform: 'scale(1) translate(-50%, -50%)',
      },
    }
  },
  mounted() {
    // const fixedWidth = document.documentElement.clientWidth.toString()
    // const fixedHeight = document.documentElement.clientHeigth.toString()
    // this.width = fixedWidth + 'px'
    // this.height = fixedHeight + 'px'
    this.setScale()
    // window.onresize = this.Debounce(this.setScale, 1000)
    window.addEventListener('resize', this.Debounce(this.setScale, 1000))
  },
  methods: {
    Debounce: (fn, t) => {
      console.log('监听改变！！！')
      const delay = t || 500
      let timer
      return function () {
        const args = arguments
        if (timer) {
          clearTimeout(timer)
        }
        const context = this
        timer = setTimeout(() => {
          timer = null
          fn.apply(context, args)
        }, delay)
      }
    },
    // 获取放大缩小比例
    getScale() {
      const w = window.innerWidth / this.width
      const h = window.innerHeight / this.height
      return w < h ? w : h
      //   return h
      //   return [w, h]
    },
    // 设置比例
    setScale() {
      const data = this.getScale()
      this.style.transform = 'scale(' + data + ') translate(-50%, -50%)'
      this.$emit('changeSize', data)
      //   this.style.transform =
      //     'scale(' +
      //     this.getScale()[0] +
      //     ',' +
      //     this.getScale()[1] +
      //     ') translate(-50%,-50%)'
    },
  },
}
</script>
<style lang="scss" scoped>
.ScreenAdapter {
  transform-origin: 0 0;
  position: absolute;
  left: 50%;
  top: 50%;
  transition: 0.3s;
  //   background: red;
  overflow: hidden;
  //   max-width: 100vw;
}
</style>
